import { nanoid } from '@reduxjs/toolkit';

const id = nanoid();

export default function Watch({ color = '#000000', ...props }: Record<string, unknown> & { color?: string }) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>watch</title>
      <defs>
        <path
          d="M10.1759425,2.4924368e-05 C11.7328381,-0.00626709382 13.0358336,1.17945879 13.1758505,2.7290372 L13.4921169,6.18308555 C15.0363371,7.6415917 16,9.708279 16,12.0000418 C16,14.3026567 15.0271891,16.3780595 13.4701411,17.8376763 L13.1559425,21.2700336 C13.0158336,22.8206248 11.7128381,24.0063507 10.16,24.0000669 L5.83405749,24.0000669 C4.2771619,24.0063507 2.97416643,22.8206248 2.83414953,21.2710464 L2.51886126,17.8273475 C0.968231488,16.368277 0,14.2972307 0,12.0000418 C0,9.69742691 0.972810884,7.62202416 2.52985893,6.1624073 L2.84405819,2.73004226 C2.9836606,1.1851916 4.27791337,0.00150313684 5.83,2.4924368e-05 Z M4.65921369,19.2712269 L4.82594251,21.09005 C4.87264549,21.6069138 5.30697731,22.0021558 5.83,22.0000418 L10.1640575,22.00005 C10.6830227,22.0021558 11.1173545,21.6069138 11.1641495,21.0890372 L11.3307728,19.2758269 C10.3166919,19.7408206 9.18861815,20.0000418 8,20.0000418 C6.80746806,20.0000418 5.67587984,19.7391107 4.65921369,19.2712269 Z M8,6.00004182 C6.54036789,6.00004182 5.20247051,6.52125015 4.16226917,7.38770551 C4.14359562,7.40736376 4.12294884,7.42470171 4.10163402,7.44118779 C2.8147032,8.54053962 2,10.1751487 2,12.0000418 C2,15.3137503 4.6862915,18.0000418 8,18.0000418 C9.45963211,18.0000418 10.7975295,17.4788335 11.8377308,16.6123781 C11.8573261,16.5918805 11.8789629,16.5737796 11.9013283,16.5566134 C13.1865571,15.4570142 14,13.8235229 14,12.0000418 C14,8.68633332 11.3137085,6.00004182 8,6.00004182 Z M8,8.00004182 C8.55228475,8.00004182 9,8.44775707 9,9.00004182 L9,11.5858283 L10.2071068,12.792935 C10.5976311,13.1834593 10.5976311,13.8166243 10.2071068,14.2071486 C9.81658249,14.5976729 9.18341751,14.5976729 8.79289322,14.2071486 L7.29289322,12.7071486 C7.10535684,12.5196122 7,12.2652583 7,12.0000418 L7,9.00004182 C7,8.44775707 7.44771525,8.00004182 8,8.00004182 Z M10.18,2.00004182 L5.83094181,2.00004137 C5.31389353,2.00052833 4.88247594,2.39509115 4.83585047,2.91104643 L4.66922725,4.72425678 C5.68330806,4.25926301 6.81138185,4.00004182 8,4.00004182 C9.19683711,4.00004182 10.3322897,4.26286029 11.3517926,4.73393218 L11.1840575,2.91003358 C11.1373545,2.39316983 10.7030227,1.99792787 10.18,2.00004182 Z"
          id={id}
        />
      </defs>
      <g id="🕹-Icons" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Feather" transform="translate(-1357, -251)">
          <g id="watch" transform="translate(1361, 251)">
            <mask id={`mask-${id}`} fill="white">
              <use xlinkHref={`#${id}`} />
            </mask>
            <use id="Combined-Shape" fill={color} fillRule="nonzero" xlinkHref={`#${id}`} />
            <g id="COLOR/-black" mask={`url(#mask-${id})`} fill={color}>
              <g transform="translate(-4, 0)" id="Rectangle">
                <rect x={0} y={0} width={24} height={24} />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
